import { render, staticRenderFns } from "./PaginationTpl.vue?vue&type=template&id=2d89a022&scoped=true&"
import script from "./PaginationTpl.vue?vue&type=script&lang=js&"
export * from "./PaginationTpl.vue?vue&type=script&lang=js&"
import style0 from "./PaginationTpl.vue?vue&type=style&index=0&id=2d89a022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d89a022",
  null
  
)

export default component.exports